<script lang="js" setup>
import { ref, onMounted, Ref } from "vue";
import { fetchGetApi, fetchPostApi } from "@/util/api";

const allData = ref([]);
import Swal from 'sweetalert2';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import { defineAsyncComponent } from 'vue';

const modalCode = defineAsyncComponent(() => import("@/components/roles/modalCode.vue"));
const elementsPerPage = ref(25);
const currentPage = ref(1);
const filterQuery = ref("");
const toast = useToast();

onMounted(async () => {
    getData()
});

function getData() {
    fetchGetApi('api/kyt/getChangeKyts').then((response) => {
        console.log(response.data);
        if (response && response.data && response.data.length > 0) {
            const sites = response.data
            console.log(sites);
            allData.value = sites;
            console.log(allData.value);
        } else {
            toast.error('Failed to fetch data')
        }
    });
}

function get_rows() {
    const start = (currentPage.value - 1) * elementsPerPage.value;
    const end = start + elementsPerPage.value;
    const query = filterQuery.value.toLowerCase();

    // Ensure allData.value is an array
    const data = Array.isArray(allData.value) ? allData.value : [];

    const filteredData = data.filter(kyt =>
        kyt.kytId.toLowerCase().includes(query) ||
        kyt.kytId.toLowerCase().includes(query)
    );

    return filteredData.slice(start, end);
}


function num_pages() {
    const query = filterQuery.value.toLowerCase();

    // Ensure allData.value is an array
    const data = Array.isArray(allData.value) ? allData.value : [];

    const filteredData = data.filter(kyt =>
        kyt.kytId.toLowerCase().includes(query) ||
        kyt.kytId.toLowerCase().includes(query)
    );

    return Math.ceil(filteredData.length / elementsPerPage.value);
}

function change_page(page) {
    currentPage.value = page;
}

function previousPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

function nextPage() {
    if (currentPage.value < num_pages()) {
        currentPage.value++;
    }
}

function confirmDelete(id) {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.isConfirmed) {
            rejectTransfer(id);
        }
    })
}
function confirmAccept(id) {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
    }).then((result) => {
        if (result.isConfirmed) {
            approveTransfer(id);
        }
    })
}

function approveTransfer(id) {
    fetchGetApi('api/kyt/approveChangeKyt/' + id).then((response) => {
        console.log(response);
        toast.success(response.data['message']);
        getData();
    });
}
function rejectTransfer(id) {
    fetchGetApi('api/kyt/rejectChangeKyt/' + id).then((response) => {
        console.log(response);
        toast.success(response.data['message']);
        getData();
    });
}
function formatDate(date) {
    if (!date) return '';

    // If the date is already in DD-MM-YYYY format, return it as is
    if (typeof date === 'string' && date.match(/^\d{2}-\d{2}-\d{4}$/)) {
        return date;
    }

    // Otherwise try to parse and format the date
    const d = new Date(date);
    if (isNaN(d.getTime())) return ''; // Return empty string for invalid dates

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
}

</script>

<template>
    <Breadcrumbs main="Apps" title="Transfer Change" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <div class="table-responsive product-table custom-scrollbar">
                    <form class="no-footer">
                        <div class="mb-3 row justify-content-between">
                            <div class="col-xs-3 col-sm-auto">
                                <label for="table-complete-search"
                                    class="col-xs-12 col-sm-auto col-form-label">Search:</label>
                                <input id="table-complete-search" type="text" class="form-control" name="searchTerm"
                                    v-model="filterQuery">
                            </div>
                        </div>
                        <table class="display table-striped table-hover table-bordered table" id="basic-1">
                            <thead>
                                <tr>
                                    <th class="sorting_asc" scope="col" style="width: 50px;">SL</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Log No</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Site Name</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Employee Name</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Kyt Type</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Priority</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Reason</th>
                                    <th class="sorting_asc text-nowrap" scope="col">New Date</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Status</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="!get_rows().length">
                                <tr class="odd">
                                    <td valign="top" colspan="7" class="dataTables_empty">No matching records found</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr class="odd" v-for="(row, index) in get_rows()" :key="index">
                                    <td class="sorting_1" style="width: 10px;">{{ index + 1 }}</td>
                                    <td class="sorting_1">{{ row.kytLogNo ?? row.kytId ?? '' }}</td>
                                    <td class="sorting_1">{{ row.siteName }}</td>
                                    <td class="sorting_1">{{ row.empName }}</td>
                                    <td class="sorting_1">{{ row.kytType ?? '' }}</td>
                                    <td class="sorting_1">{{ row.isPriority ?? '' }}</td>
                                    <td class="sorting_1">{{ row.reason }}</td>
                                    <td class="sorting_1">{{ formatDate(row.date) }}</td>
                                    <td class="sorting_1">{{ row.status }}</td>
                                    <td>
                                        <button class="btn btn-success btn-xs me-2" type="button"
                                            data-original-title="btn btn-success btn-xs" @click='confirmAccept(row._id)'
                                            title=""
                                            v-if="row.status != 'Approved' && row.status != 'Rejected'">Accept</button>
                                        <button class="btn btn-danger btn-xs me-2" type="button"
                                            data-original-title="btn btn-danger btn-xs" @click='confirmDelete(row._id)'
                                            title=""
                                            v-if="row.status != 'Approved' && row.status != 'Rejected'">Reject</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                    </form>
                </div>

                <ul class="pagination py-2 justify-content-end pagination-primary">
                    <li class="page-item" @click="previousPage">
                        <a class="page-link">Previous</a>
                    </li>
                    <li class="page-item" v-for="i in num_pages()" :key="i" :class="[i == currentPage ? 'active' : '']"
                        @click="change_page(i)">
                        <a class="page-link">{{ i }}</a>
                    </li>
                    <li class="page-item" @click="nextPage">
                        <a class="page-link">Next</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
